import { createSlice } from '@reduxjs/toolkit';

const userData = createSlice({
  name: 'userData',
  initialState: {
    userDetails: {},
    refreshUserData: false
  },
  reducers: {
    updateUserDetails: (state, action) => {
      state.userDetails = action.payload
    },
    updateRefreshUserData: (state, action) => {
      state.refreshUserData = !state.refreshUserData
    },
  },
});

export const { updateUserDetails, updateRefreshUserData } = userData.actions;

export default userData.reducer;
